/**
 * Inline marker shown in place of a sensitive VALUE the viewer's role
 * can't read. Wired today for raw event payloads (ScopedPage);
 * prompt/response-text redaction is a follow-up surface that will reuse
 * this component. Per the RBAC design: hide the value, NOT the whole
 * pane, so the redaction stays legible to both the analyst (who sees
 * *that* data exists but is gated) and the monitored developer (for whom
 * it's a visible privacy guarantee, not a silent omission).
 *
 * Purely presentational. The caller decides whether to render this vs.
 * the real value via `hasSensitivePermission` (permissions.js). `what`
 * is folded into the accessible name so screen-reader / touch users know
 * which value was withheld when several markers share a pane.
 */
export default function RedactedByPolicy({ what = "This content", className = "" }) {
    return (
        <span
            className={[
                "inline-flex items-center gap-[6px] rounded-[2px] border border-dashed border-[color:var(--line)]",
                "bg-[color:var(--control-bg)] px-[8px] py-[4px] text-[11px] leading-[1.3] text-[color:var(--muted)]",
                className,
            ].join(" ")}
            aria-label={`${what} redacted by your organization's data-access policy. Your role does not include permission to view it.`}
            title={`${what} is hidden by your organization's data-access policy. Your role doesn't include permission to view it.`}
        >
            <svg viewBox="0 0 16 16" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.4" className="h-[11px] w-[11px] shrink-0">
                <rect x="3.5" y="7" width="9" height="6" rx="1" />
                <path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" />
            </svg>
            <span>Redacted by policy</span>
        </span>
    );
}
